export default __webpack_public_path__ + "static/media/logo-black.7435e524.png";